import { render, staticRenderFns } from "./Dingdanguanli.vue?vue&type=template&id=70ff18b4&scoped=true&"
import script from "./Dingdanguanli.vue?vue&type=script&lang=js&"
export * from "./Dingdanguanli.vue?vue&type=script&lang=js&"
import style0 from "./Dingdanguanli.vue?vue&type=style&index=0&id=70ff18b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ff18b4",
  null
  
)

export default component.exports